import { Column } from '@qtek/shared/models';

/**
 * Display overlay for the v2 task grid meta.
 *
 * `TaskEntityTask.attachTaskGraphMeta` hand-builds its graph instead of going through
 * `SchemaService.getRootPropertyBuilder`, so it ships English labels and drops the icons
 * the schema type configs carry. The FE renders meta labels through `translate`, which
 * yields '' for anything that is not a key — hence blank filter/sort entries. Re-apply the
 * keys and icons v1 served from `~task.json` / `type/task*.json` until the backend does.
 */
export const TASK_META_DISPLAY: Record<
  string,
  { label: string; icon: string }
> = {
  actionType: { label: 'GNR_TASK_TYPE', icon: 'category' },
  statusType: { label: 'GNR_STATUS', icon: 'task_alt' },
  executionTime: { label: 'GNR_EXECUTE_DATE', icon: 'date_range' },
  user: { label: 'GNR_ASSIGNEE', icon: 'person' },
  authorId: { label: 'GNR_AUTHOR', icon: 'person' },
};

export const STATUS_MAP: Record<string, string> = {
  active: 'GNR_ACTIVE',
  todo: 'GNR_TODO',
  done: 'GNR_DONE',
  closed: 'GNR_STG_CLOSED',
  broken: 'GNR_BROKEN',
  disabled: 'GNR_DISABLED',
  failed: 'GNR_FAILED',
  pending: 'GNR_PENDING',
  expired: 'GNR_EXPIRED',
} as const;

export const TASK_TABLE_COLUMNS: Column[] = [
  {
    id: 'actionType',
    label: 'GNR_TASK_TYPE',
    sortable: true,
    minWidth: 100,
    maxWidth: 100,
    hideOrder: 0,
    format: 'action',
    sticky: true,
  },
  {
    id: 'params.title',
    label: 'GNR_TITLE',
    sortable: false,
    minWidth: 250,
    maxWidth: 350,
    hideOrder: 1,
    sticky: true,
  },
  {
    id: 'statusType',
    label: 'GNR_STATUS',
    sortable: false,
    minWidth: 100,
    maxWidth: 150,
    hideOrder: 3,
    format: 'status',
  },
  {
    id: 'params.assignPrsUsr',
    label: 'GNR_ASSIGNEE',
    sortable: true,
    minWidth: 200,
    hideOrder: 4,
    format: 'assignee',
  },
  {
    id: 'executionTime',
    label: 'GNR_EXECUTE_DATE',
    sortable: true,
    minWidth: 140,
    maxWidth: 200,
    hideOrder: 5,
    format: 'date',
  },
  {
    id: 'params.authorFullName',
    label: 'GNR_AUTHOR',
    sortable: true,
    minWidth: 200,
    hideOrder: 6,
    format: 'usrId',
  },
  {
    id: 'params.dealName',
    label: 'GNR_DEAL',
    sortable: true,
    minWidth: 200,
    hideOrder: 7,
  },
  {
    id: 'params.note',
    label: 'GNR_ASSOCIATED_NOTE',
    sortable: false,
    minWidth: 200,
    hideOrder: 8,
    format: 'note',
  },
  {
    id: '_id',
    label: '',
    disableTranslate: true,
    minWidth: 48,
    maxWidth: 48,
    hideOrder: 9,
    stickyEnd: true,
  },
];
